import React, { useState } from "react";
import { useTable, useGlobalFilter, useSortBy } from "react-table";
import { useRecoilValue } from "recoil";

const ReservationHotelListTable = React.memo(({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
  } = useTable({ columns, data }, useGlobalFilter, useSortBy);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // 0 : 종료 1 : 투어중 2 : 투어예정
  function checkTourState(startDate, endDate) {
    let startD = new Date(startDate);
    let endD = new Date(endDate);
    startD.setHours(0, 0, 0, 0);
    endD.setHours(0, 0, 0, 0);

    if (today > endD)
      return 0;

    if (today >= startD && today <= endD)
      return 1;

    if (today < startD)
      return 2;

    return 0;
  }

  return (
    <>
      <table {...getTableProps()} style={{ borderCollapse: "collapse" }} className="w-full h-fit">
        <thead>
          {
            headerGroups.map((headerGroup) => {
              let headerProps = headerGroup.getHeaderGroupProps();
              let key = headerProps.key;
              delete headerProps.key;

              return (
                <tr key={key} {...headerProps} >
                  {headerGroup.headers.map((column) => {
                    let columnProps = column.getHeaderProps(column.getSortByToggleProps())
                    let key = column.id;
                    delete columnProps.key;

                    return (
                      <th key={key} {...columnProps} style={{
                        minWidth: column.minWidth,
                        width: column.width,
                        borderTop: "2px solid rgb(0, 0, 0)",
                        borderRight: "1px solid rgb(0, 0, 0)",
                        borderLeft: "1px solid rgb(0, 0, 0)",
                        padding: "5px",
                        fontSize: 13,
                        color: "#fff",
                        position: "sticky",
                        top: 0,
                        background: "#000",
                      }}>
                        {column.render("Header")}
                      </th>
                    )
                  }
                  )}
                </tr>
              )
            })
          }
        </thead>
        <tbody {...getTableBodyProps()}>
          {
            rows.map((row) => {
              prepareRow(row);

              let start = row.original.startDate;
              let end = row.original.endDate;

              let tourState = checkTourState(start, end);
              let rgb = tourState === 0 ? "#7f7f7f" : tourState === 1 ? "#00CD3C" : "#0570DB";

              return (
                <tr {...row.getRowProps()} key={row.index} style={{ color: rgb }}>
                  {row.cells.map((cell) => {
                    let cellProps = cell.getCellProps({ style: cell.column.style, });
                    let cellKey = cell.row.id + " " + cell.column.index;
                    delete cellProps.key;

                    return (
                      <td key={cellKey} {...cellProps} className="">
                        {
                          cell.render("Cell")
                        }
                      </td>
                    )
                  })}
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </>
  );
});

export default ReservationHotelListTable;
